/**
 * The D4 branch home tiles and their default arrangement in the configurable dashboard.
 *
 * The engine lays widgets out in 3 column tracks with masonry rows. D4's 12-column design maps onto that
 * exactly: Treasury spans 2 tracks next to To validate (1); every other tile takes 1 track, three per row.
 * Equal heights come from the tiles themselves (a fixed hero height for the first row, a fixed regular height
 * for the rest), so the masonry rows line up like the design.
 */

export enum HomeTileId {
  Treasury = "treasury",
  Approvals = "approvals",
  Members = "members",
  RecentVisitors = "recentVisitors",
  Birthdays = "birthdays",
  NewMembers = "newMembers",
  Budget = "budget",
  Spending = "spending",
}

/** D4 design order: the hero row, then two rows of three. */
export const HOME_D4_TILE_ORDER: readonly HomeTileId[] = [
  HomeTileId.Treasury,
  HomeTileId.Approvals,
  HomeTileId.Members,
  HomeTileId.RecentVisitors,
  HomeTileId.Birthdays,
  HomeTileId.NewMembers,
  HomeTileId.Budget,
  HomeTileId.Spending,
]

/** The tiles of the taller first row. */
export const HOME_D4_HERO_TILES: ReadonlySet<HomeTileId> = new Set([HomeTileId.Treasury, HomeTileId.Approvals])

/** What a tile is doing right now: still loading (draw its skeleton), ready (draw it), or absent (leave it out). */
export enum HomeTileState {
  Loading = "loading",
  Ready = "ready",
  Absent = "absent",
}

type QueryLike = { isPending: boolean; isError: boolean; data?: unknown }

/** A tile backed by a query: absent when not allowed or when the read failed (a refusal will refuse again). */
export function tileStateFor(allowed: boolean, query: QueryLike, hasContent = true): HomeTileState {
  if (!allowed) return HomeTileState.Absent
  if (query.isError) return HomeTileState.Absent
  if (query.isPending || query.data === undefined) return HomeTileState.Loading
  return hasContent ? HomeTileState.Ready : HomeTileState.Absent
}
